module.exports = __webpack_public_path__ + "static/media/SF-Pro-Text-Bold.f186187b.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-Pro-Text-Bold.otf
// module id = 1661
// module chunks = 0